import {
    HttpResponse,
    EventModel,
    QueryModel,
    RequestParams,
    EventModelIEnumerableApiResultSuccess,
    EventModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class EventsDataService implements CrudService<EventModel, EventModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<EventModel>): Promise<CrudListResponse<EventModel>> {
        return ApiService.api.getEventBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<EventModel>> {
        return ApiService.api.getEventById(id, params);
    }

    create(item: EventModel, params?: RequestParams): Promise<CrudResponse<EventModel>> {
        return ApiService.api.insertEvent(item, params);
    }

    update(item: EventModel, params?: RequestParams): Promise<EventModel> {
        return ApiService.api.updateEvent(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<EventModel> {
        return ApiService.api.patchEvent(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<EventModel>): Promise<CrudListResponse<EventModel>> {
        return ApiService.api.deleteEvents(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<EventModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
